import React from "react"
import {
    Popover,
    PopoverTrigger,
    Button,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    Checkbox,
    Input,
    Text,
    VStack,
} from "@chakra-ui/react"
import { FaFilter } from "react-icons/fa"

export type FilterType = {
    overMatches?: number
    sortByAtsPlusMinus?: boolean
    sortByWeightedAts?: boolean
    sortByMasterlock?: boolean
    sortByAbs?: boolean
    maxGamesToCompare?: number
}

const Filters: React.FC<{
    filters?: FilterType
    setFilters: (filters?: FilterType) => void
    columns: number
    setColumns: (num: number) => void
}> = ({ filters, setFilters, columns, setColumns }) => {
    return (
        <Popover>
            <PopoverTrigger>
                <Button colorScheme={!!filters ? "blue" : "gray"}>
                    <FaFilter />
                    More
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverBody py={8}>
                    <VStack alignItems="flex-start" flexDir="column">
                        <Label>Only show games over # matches:</Label>
                        <Input
                            value={filters?.overMatches || ""}
                            onChange={e =>
                                setFilters({
                                    ...filters,
                                    overMatches: parseInt(e.target.value),
                                })
                            }
                        />
                        <Label>Sort by differentials:</Label>
                        <Checkbox
                            onChange={() =>
                                setFilters({
                                    ...filters,
                                    sortByMasterlock: !filters?.sortByMasterlock,
                                })
                            }
                        >
                            Sort by Masterlock number
                        </Checkbox>
                        <Checkbox
                            onChange={() =>
                                setFilters({
                                    ...filters,
                                    sortByAtsPlusMinus: !filters?.sortByAtsPlusMinus,
                                })
                            }
                        >
                            Sort by average +/-
                        </Checkbox>
                        <Checkbox
                            onChange={() =>
                                setFilters({
                                    ...filters,
                                    sortByWeightedAts: !filters?.sortByWeightedAts,
                                })
                            }
                        >
                            Sort by weighted +/-
                        </Checkbox>
                        <Checkbox
                            onChange={() =>
                                setFilters({
                                    ...filters,
                                    sortByAbs: !filters?.sortByAbs,
                                })
                            }
                        >
                            Sort by absolute value
                        </Checkbox>
                        <Label>Max Games to Compare</Label>
                        <Input
                            value={filters?.maxGamesToCompare || ""}
                            onChange={e =>
                                setFilters({
                                    ...filters,
                                    maxGamesToCompare: isNaN(
                                        parseInt(e.target.value)
                                    )
                                        ? undefined
                                        : parseInt(e.target.value),
                                })
                            }
                        />
                        <Button
                            mt={4}
                            variant="outline"
                            onClick={() => setFilters(undefined)}
                        >
                            Clear All Filters
                        </Button>
                    </VStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}

export default Filters

const Label: React.FC = ({ children }) => (
    <Text
        color="gray.500"
        lineHeight="shorter"
        letterSpacing="tight"
        pt={4}
        fontSize="xs"
    >
        {children}
    </Text>
)
